import { useUserTagLang } from './useUserTagLang';

import type { UserTagType } from 'shared/domain';

export function useUserTag(props: Props) {
  const lang = useUserTagLang(props);
  return {
    lang,
  };
}

interface Props {
  userTag: UserTagType;
}
